import { useState } from 'react'
import { Component, Div } from '../utils/flags'

export const Block_91 = () => {
  return <Wrapper></Wrapper>
}

const inpus = [...Array(10).keys()]
const Wrapper = Component.flex.article()
